
import { Vue, Component, Prop } from 'vue-property-decorator';
import ButtonComponent from '@/components/ButtonComponent.vue';

@Component({
  components: {
    ButtonComponent
  }
})
export default class ShowMoreComponent extends Vue {
  @Prop({ type: String, default: 'Показать все' }) btnShow: string;
  @Prop({ type: String, default: 'Скрыть' }) btnHide: string;
  @Prop({ type: Number, default: 0 }) minHeight: number;

  isOpen: boolean = false;
  isBtnNeeded: boolean = false;
  currentMaxHeight: number = 0;

  toggle() {
    const content = (this.$refs.showMore as HTMLElement);
    if (this.isOpen) this.currentMaxHeight = this.minHeight;
    else this.currentMaxHeight = content.scrollHeight;

    this.isOpen = !this.isOpen;
  }

  mounted() {
    this.currentMaxHeight = this.minHeight;
    this.isBtnNeeded = this.$refs.showMore && ((this.$refs.showMore as HTMLElement).scrollHeight) > this.minHeight;
  }
}
